<template>
  <div>
    <v-form @submit.prevent="login">
      <EmailInput v-model="loginData.email" label="メールアドレス" />
      <PasswordInput v-model="loginData.password" label="パスワード" />
      <LoginButton label="ログインする" @login="login" />
    </v-form>
    <LoadingOverlay />
  </div>
</template>
<script>
import LoginButton from '/src/components/pages/SignIn/LoginButton'
import EmailInput from '/src/components/uiParts/inputFields/EmailInput'
import PasswordInput from '/src/components/uiParts/inputFields/PasswordInput'
import { mapGetters, mapState } from 'vuex'
import LoadingOverlay from '/app/components/commons/LoadingOverlay'

export default {
  name: 'SignInContainer',
  components: {
    LoadingOverlay,
    LoginButton,
    EmailInput,
    PasswordInput
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser,
      authUser: (state) => state.UserAuthStore.currentUserAuth
    }),
    ...mapGetters({
      isManager: 'UserAuthStore/isManager',
      isWriter: 'UserAuthStore/isWriter',
      isClient: 'UserAuthStore/isClient'
    })
  },
  data () {
    return {
      loginData: {
        email: '',
        password: '',
        withCredentials: true
      }
    }
  },
  methods: {
    login () {
      this.$store.dispatch('LoaderStore/displayLoader')
      this.$store
        .dispatch('UserAuthStore/logIn', { user_auth: this.loginData })
        .then(async (response) => {
          const payload = {
            status: 200,
            message: 'ログインに成功しました。'
          }
          this.redirect()
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .catch((e) => {
          const payload = {
            status: e.response.status,
            message: e.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    async redirectDefaultPath () {
      if (window.origin === process.env.MASTER_ORIGIN) {
        if (this.isManager) {
          return '/master_admin'
        } else if (this.isWriter) {
          return '/master_writer'
        } else if (this.isClient) {
          return '/master_client'
        }
      }

      if (this.authUser.isAdmin) {
        return '/admin'
      } else {
        return '/writers'
      }
    },
    async redirect () {
      const redirect = this.$route.query.redirect || await this.redirectDefaultPath()
      await location.replace(redirect)
    }
  }
}
</script>
